var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.627,
    height: 34.627,
    viewBox: "0 0 34.627 34.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart",
    d: "M23.642,2h0a.818.818,0,0,0-.866.866v12.12a.818.818,0,0,0,.866.866h12.12a.818.818,0,0,0,.866-.866h0A13.08,13.08,0,0,0,23.642,2Zm.866,12.12V3.731A11.314,11.314,0,0,1,34.9,14.12Zm7.791,6.06H18.448V6.328a.818.818,0,0,0-.866-.866A15.582,15.582,0,1,0,33.165,21.045h0A.818.818,0,0,0,32.3,20.179ZM18.448,34.9a13.878,13.878,0,1,1-1.731-27.7V21.045a.818.818,0,0,0,.866.866H31.433A14.107,14.107,0,0,1,18.448,34.9Z",
    transform: "translate(-2 -2)",
    fill: "#006664"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.42f6640b9e8bbaa7a44291b8f2044f76.svg";
export { ForwardRef as ReactComponent };